(function () {
    angular.module('PWAPoCApp').constant('appVersion', '2026.10.15');
})();
